<template>
  <CCard>
    <CCardHeader
      style="background:#1a3665;color:white"
      class="d-flex align-items-center font-weight-bold"> Master Cabang
    
      <template v-if="role_status && role_status.status_create">
      <CButton 
        color="success" 
        style="float:right" class="btn-md ml-auto" 
        @click="createData()">Tambah</CButton>
      </template>
      <template v-else>
      <CButton 
        color="secondary" 
        style="float:right" class="btn-md ml-auto" 
        disabled>Tambah</CButton>
      </template>

    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol xl="12">
          <CSelect
            label="Data Perhalaman"
            class="float-left"
            @change="changePageSize"
            :options="[10, 25, 100, 'Semua Data']"
          />
          <CInput
            label="Pencarian"
            class="float-right"
            placeholder="Cari Data .."
            v-model="search"
          />
          <br />
        </CCol>
      </CRow>
        <div class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>
            <template #kodeCabang="{item}">
              <td class="py-2 font-weight-bold">{{item.kodeCabang ? item.kodeCabang : "-"}}</td>
            </template>
            <template #namaCabang="{item}">
              <td class="py-2">{{item.namaCabang ? item.namaCabang : "-"}}</td>
            </template>
            <template #alamatCabang="{item}">
              <td class="py-2">{{item.alamatCabang ? item.alamatCabang : "-"}}</td>
            </template>
            <template #status="{item}">
              <td class="py-2 text-left">
                <p  v-if="item.status == 1" class="text-success font-weight-bold"> Aktif</p>
                <p  v-else class="text-danger font-weight-bold"> Tidak Aktif</p>
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 text-center d-flex align-items-center">
                <template v-if="role_status && role_status.status_update">
                <CButton v-c-tooltip="'Ubah'" color="info" square size="sm" class="mr-1" @click="updateData(item, index)">
                  <font-awesome-icon icon="edit" />
                </CButton>&nbsp;&nbsp;
                </template>
                <template v-else>
                <CButton v-c-tooltip="'Ubah'" color="secondary" square size="sm" class="mr-1" disabled>
                  <font-awesome-icon icon="edit" />
                </CButton>&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_delete">
                <CButton v-c-tooltip="'Hapus'" color="danger" square size="sm" @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
                <template v-else>
                <CButton v-c-tooltip="'Hapus'" color="secondary" square size="sm" disabled>
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </div>
      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true">

        <CForm v-on:submit.prevent="postData">
          <CRow>
            <div class="modal-body">
              <form>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label for="kode_cabang font-weight-bold" class="font-weight-bold">Kode</label>
                    <input
                      type="text"
                      class="form-control"
                      :class="{
                        'is-invalid': $v.formData.kodeCabang.$error, 
                      }"
                      id="kode_cabang"
                      placeholder="Masukkan Kode Cabang"
                      v-model="formData.kodeCabang"
                      @input="setKodeCabang($event.target.value)"
                    />                           
                  </div>

                  <div class="form-group col-md-12">
                    <label for="nama_cabang font-weight-bold" class="font-weight-bold">Nama Cabang</label>
                    <input
                      type="text"
                      class="form-control"
                      :class="{
                        'is-invalid': $v.formData.namaCabang.$error, 
                      }"
                      id="nama_cabang"
                      placeholder="Masukkan Nama Cabang"
                      v-model="formData.namaCabang"
                      @input="setNamaCabang($event.target.value)"
                    />                          
                  </div>

                </div>

                <div class="form-group">
                  <label for="nomor_telp" class="font-weight-bold">Nomor Telepon</label>
                  <input
                    type="number"
                    class="form-control"
                    :class="{
                      'is-invalid': $v.formData.noTelephone.$error, 
                    }"
                    id="nomor_telp"
                    placeholder="Masukkan Nomor Telepon Cabang"
                    v-model="formData.noTelephone"
                    @input="setNoTelephone($event.target.value)"
                  />        
                </div>

                <div class="form-group">
                  <label for="alamat" class="font-weight-bold">Alamat</label>
                  <textarea
                    class="form-control"
                    :class="{
                      'is-invalid': $v.formData.alamatCabang.$error, 
                    }"
                    id="alamat"
                    placeholder="Masukkan Alamat Cabang"
                    v-model="formData.alamatCabang"
                    @input="setAlamatCabang($event.target.value)"
                  />
                </div>
                
                <div class="form-group">
                  <label for="fax" class="font-weight-bold">FAX</label>
                  <input
                    type="number"
                    class="form-control"
                    :class="{
                      'is-invalid': $v.formData.noFax.$error, 
                    }"
                    id="fax"
                    placeholder="Masukkan Nomor FAX"
                    v-model="formData.noFax"
                    @input="setNoFax($event.target.value)"
                  />        
                </div>

                <div>
                  <label for class="font-weight-bold">Status</label>
                  <div class="d-flex align-items-center">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        class="custom-control-input"
                        name="customRadio"
                        id="aktif"
                        value="1"
                        v-model="formData.status"
                        checked
                      />
                      <label class="custom-control-label" for="aktif">Aktif</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        class="custom-control-input"
                        name="customRadio"
                        id="tidak_aktif"
                        value="0"
                        v-model="formData.status"
                      />
                      <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
                    </div>
                  </div>
                  <span v-if="$v.formData.status.$error" class="text-danger">
                    *Mohon pilih status
                  </span>
                </div>
                
              </form>
            </div>
          </CRow>
        </CForm>

        <template #header>
          <h6 class="modal-title h4 font-weight-bold">{{title}}</h6>
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
  </CCard>
</template>

<script>
import { required } from "vuelidate/lib/validators";

import CabangService from "@/services/datamaster/cabang.service";
import { AlertUtils } from "@/mixins/AlertUtils"
import { exportUtils } from '@/mixins/exportUtils';

const fields = [
  { key: "no" },
  { key: "kodeCabang"},
  { key: "namaCabang", _style: "width: 20%" },
  { key: "alamatCabang", _style: "text-align: left" },
  { key: "noTelephone", label: "Nomor Telepon" },
  { key: "noFax" },
  { key: "status", _style: " text-align: center" },
  { key: "aksi", _style: "width:11%; text-align: center" }
];

export default {  
  name: "Cabang",

  mixins : [
    AlertUtils,
    exportUtils
  ],

  data() {
    return {
      search: "",
      items: [],
      actionPost: "",
      pageSize: "",
      formData: {
        kodeCabang: "",
        namaCabang: "",
        alamatCabang: "",
        noTelephone: "",
        noFax: "",
        status: "",
        idCabang: ""
      },
      pagination: {
        totalPages: 0
      },
      title : '',
      fields,
      currentPage: 0,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      indexed: 0,
      collapseDuration: 0,
      content: [],
      timeout : null,    
      role_status : null,  
    };
  },

  validations: {
    formData: {
      kodeCabang: { required },
      namaCabang: { required },
      alamatCabang: { required },
      noTelephone: { required },
      noFax: { required },      
      status: { required }
    },
  },

  mounted() {
    this.getData("0", this.pageSize, "default");
    this.roleData()
    // comment console console.log(this.pageSize);
  },
  watch: {
    search: function (val) {
       clearTimeout(this.timeout);
      var vm = this
      this.timeout = setTimeout(function () {
          // enter this block of code after 1 second
          // handle stuff, call search API etc.
          vm.getData("0", vm.pageSize, vm.search);
      }, 1000);
    },
    currentPage: function(val) {
      // alert(val-1);
      var page = val - 1;
      this.indexed = page * 10;
      // alert(this.indexed);
      this.getData(val - 1, this.pageSize, this.search);
      // this.getData(val-1);
    },
    myModal: function() {
      if(!this.myModal) {
        this.clearValidation();
      }
    }
  },
  methods: {
    // Fungsi Validasi
    setKodeCabang(value) {
      this.formData.kodeCabang = value;
      this.$v.formData.kodeCabang.$touch();
      if(!this.$v.formData.kodeCabang.$error) {
        document.getElementById("kode_cabang").classList.add("is-valid")
      }
    },
    setNamaCabang(value) {
      this.formData.namaCabang = value;
      this.$v.formData.namaCabang.$touch();
      if(!this.$v.formData.namaCabang.$error) {
        document.getElementById("nama_cabang").classList.add("is-valid")
      }
    },
    setAlamatCabang(value) {
      this.formData.alamatCabang = value;
      this.$v.formData.alamatCabang.$touch();
      if(!this.$v.formData.alamatCabang.$error) {
        document.getElementById("alamat").classList.add("is-valid")
      }
    },
    setNoTelephone(value) {
      this.formData.noTelephone = value;
      this.$v.formData.noTelephone.$touch();
      if(!this.$v.formData.noTelephone.$error) {
        document.getElementById("nomor_telp").classList.add("is-valid")
      }
    },
    setNoFax(value) {
      this.formData.noFax = value;
      this.$v.formData.noFax.$touch();
      if(!this.$v.formData.noFax.$error) {
        document.getElementById("fax").classList.add("is-valid")
      }
    },

    changePageSize(e) {
      // comment console console.log(e.target.value);
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },
    pageChange() {
      // this.getData(currentPage);
      this.getData(currentPage, this.pageSize, this.search);
    },
   
    deleteData(item, index) {
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            CabangService.deleteCabang(this.formData)
              .then(response => {
                // comment console console.log(response);
                this.alertDeleteSuccess();
                // this.getData("1");
                this.getData("0", this.pageSize, this.search);
              })
              .catch(error => {
                this.alertError();
                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },
    getData(currentPage, pageSize, filter) {
      if (filter == "") {
        filter = "default";
      }
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      CabangService.getCabang(currentPage, pageSize, filter)
        .then(response => {
          // comment console console.log(response.data);

          // comment console console.log(response.data.data.content);
          this.items = response.data.data.content;
          // // comment console console.log("ini data cabang")
          // // comment console console.log(items);
          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;
          loader.hide();
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
        });
    },
    createData() {
      this.myModal = true;
      this.formData = {};
      this.actionPost = "insert";
      this.title = "Tambah";
    },

    updateData(item, index) {
      this.myModal = true;
      this.formData = item;
      this.actionPost = "update";
      this.title = "Edit";
    },

    postData() {        
      this.$v.$touch();    
      if (this.actionPost == "insert") {        
        if (this.$v.$invalid) {
          return;
        } else {          
          this.insertData(this.formData);          
        }        
      } else if (this.actionPost == "update") {
        if (this.$v.$invalid) {
          return;
        } else {          
          this.putData();
        }                
      }      
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      // comment console console.log(formData);
      // comment console console.log("post");
      var vm = this;
      CabangService.postCabang(formData)
        .then(response => {
          loader.hide();
          vm.myModal = false;
          vm.clearValidation();
          vm.alertSuccess();
          vm.getData("0", this.pageSize, this.search);
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
          vm.alertError(error.response.data.message);
        });
    },

    putData() {
      // comment console console.log("put");
      // comment console console.log(this.formData);
      var vm = this;
      CabangService.putCabang(this.formData)
        .then(response => {
          vm.myModal = false;
          vm.clearValidation();
          vm.alertEditSuccess();
          vm.getData("0", this.pageSize, this.search);
        })
        .catch(error => {
          // comment console console.log(error);

          vm.alertError(error.response.data.message);
        });
    },    

    clearValidation() {
      this.$v.$reset()
      document.getElementById('kode_cabang').classList.remove('is-valid');
      document.getElementById('nama_cabang').classList.remove('is-valid');
      document.getElementById('alamat').classList.remove('is-valid');
      document.getElementById('nomor_telp').classList.remove('is-valid');
      document.getElementById('fax').classList.remove('is-valid');
    },

    exportDataCabang() {
      CabangService.exportCabang()
        .then(response => {          
          this.exportData(response.data, 'Cabang');
          this.alertExportSuccess();
          this.getData("0", this.pageSize, "default");
        })
        .catch(error => {          
          this.alertExportFailed();
          this.getData("0", this.pageSize, "default");
        })
    },
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
      this.role_status = data;
    }
  }
};
</script>